import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { MessageCircle, Lock } from "lucide-react";
import { initials, timeAgo } from "@/lib/format";
import { toast } from "sonner";

const Conversations = () => {
  const navigate = useNavigate();
  const [convos, setConvos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/conversations")
      .then(({ data }) => setConvos(data.conversations))
      .catch((e) => toast.error(apiError(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl">Messages</h1>
      {loading ? (
        [0, 1, 2].map((i) => <Skeleton key={i} className="h-16 rounded-xl" />)
      ) : convos.length === 0 ? (
        <div className="text-center py-16 text-muted-foreground">
          <MessageCircle className="h-8 w-8 mx-auto mb-2" />
          <p>Aucune conversation. Ajoutez des amis pour commencer.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {convos.map((c) => (
            <Card
              key={c.user.id}
              className="p-3 rounded-2xl flex items-center gap-3 cursor-pointer hover:bg-secondary/40 transition-colors"
              onClick={() => navigate(`/messages/${c.user.username}`)}
              data-testid={`conversation-item-${c.user.username}`}
            >
              <Avatar className="h-11 w-11"><AvatarFallback className="bg-accent text-accent-foreground text-xs font-semibold">{initials(c.user.username)}</AvatarFallback></Avatar>
              <div className="flex-1 min-w-0">
                <p className="font-medium truncate">@{c.user.username}</p>
                <p className="text-xs text-muted-foreground truncate flex items-center gap-1">
                  {c.preview === "Photo verrouillée" && <Lock className="h-3 w-3" />}
                  {c.preview || "Nouvelle conversation"}
                </p>
              </div>
              <span className="text-[11px] text-muted-foreground shrink-0">{timeAgo(c.last_at)}</span>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Conversations;
